<template>
  <div class="">
    <v-card flat class="mb-4">
      <v-card-text class="pb-2 px-0">
        <v-row>
          <v-col md="4">
            <v-text-field
              hide-details="auto"
              type="date"
              :dense="false"
              solo
              flat
              v-model="searchParams.date_start"
              background-color="grey lighten-4"
              label="Data Inicial"
              @change="select(1)"
            />
          </v-col>
          <v-col md="4">
            <v-text-field
              background-color="grey lighten-4"
              hide-details="auto"
              type="date"
              solo
              :dense="false"
              flat
              v-model="searchParams.date_end"
              label="Data Final"
              @change="select(1)"
            />
          </v-col>
          <v-col md="4">
            <ProductSearch
              flat
              solo
              :dense="false"
              :showStock="true"
              @input="setProduct()"
              v-model="search"
              background-color="grey lighten-4"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row>
      <v-col md="4">
        <company-select
          chips
          multiple
          v-model="searchParams.company_id"
          :item-value="(val) => val.id"
          :itemText="(val) => val.short_name"
          solo
          flat
          background-color="grey lighten-4"
          :dense="false"
          @change="select(1)"
        />
      </v-col>
      <v-col md="8">
        <v-chip-group
          v-model="searchParams.sale_status"
          multiple
          mandatory
          @change="select(1)"
        >
          <v-chip filter outlined value="sale" small>
            Venda
          </v-chip>
          <v-chip filter outlined value="order" small>
            Pedido
          </v-chip>
          <v-chip filter outlined value="draft" small>
            Rascunho
          </v-chip>
          <v-chip filter outlined value="proposal" small>
            Proposta
          </v-chip>
          <v-chip filter outlined value="waiting_approval" small>
            Aguardando Aprovação
          </v-chip>
          <v-chip filter outlined value="canceled" small>
            Cancelado
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col>
        <v-card
          outlined
          color="grey lighten-4 "
          elevation="0"
          class="fill-height"
        >
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Quantidade Total
              <br />
              <b class="text-h4">
                {{ $format.decimal(totals.total_quantity || 0) }}
              </b>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col>
        <v-card color="grey lighten-4" elevation="0">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Quantidade a Entregar
              <br />
              <b class="text-h4 ">
                {{ $format.decimal(totals.total_quantity_to_delivery || 0) }}
              </b>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card outlined dark elevation="0">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Quantidade Processando
              <br />
              <b class="text-h4">
                {{
                  $format.decimal(totals.total_quantity_pending_delivery || 0)
                }}
              </b>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col>
        <v-card outlined color="primary" dark elevation="0" class="fill-height">
          <v-card-text class="d-flex align-center justify-space-between">
            <div>
              Quantidade Entregue / Em Rota
              <br />
              <b class="text-h4">
                {{
                  $format.decimal(
                    totals.total_quantity_delivered_confirmed || 0
                  )
                }}
              </b>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mb-4">
      <v-col>
        <v-card flat color="grey lighten-5">
          <v-card-text class="py-4 px-5">
            <v-row class="align-center">
              <v-col md="8">
                <div class="d-flex align-center flex-wrap">
                  <span
                    class="text-body-1 font-weight-medium mr-4 text-primary"
                  >
                    Ordenar por:
                  </span>
                  <v-chip-group
                    v-model="searchParams.order_by"
                    mandatory
                    active-class="primary white--text"
                    @change="select(1)"
                  >
                    <v-chip filter value="updated_at" class="mx-1" small>
                      Última Atualização
                    </v-chip>
                    <v-chip
                      filter
                      value="quantity_to_delivery"
                      class="mx-1"
                      small
                    >
                      Quantidade a Entregar
                    </v-chip>
                    <v-chip filter value="total_quantity" class="mx-1" small>
                      Quantidade Total
                    </v-chip>
                    <v-chip
                      filter
                      value="quantity_pending_delivery"
                      class="mx-1"
                      small
                    >
                      Quantidade Pendente
                    </v-chip>
                    <v-chip
                      filter
                      value="quantity_delivered_confirmed"
                      class="mx-1"
                      small
                    >
                      Quantidade Entregue
                    </v-chip>
                  </v-chip-group>
                </div>
              </v-col>
              <v-col md="4">
                <div class="d-flex align-center justify-end flex-wrap">
                  <span
                    class="text-body-1 font-weight-medium mr-3 text-primary"
                  >
                    Ordem:
                  </span>
                  <v-chip-group
                    v-model="searchParams.order_direction"
                    mandatory
                    active-class="primary white--text"
                    @change="select(1)"
                    class="mr-4"
                  >
                    <v-chip filter value="asc" class="mx-1" small>
                      Crescente
                    </v-chip>
                    <v-chip filter value="desc" class="mx-1" small>
                      Decrescente
                    </v-chip>
                  </v-chip-group>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <template v-if="products.groupedSalesByDeliveryProducts">
      <v-row>
        <v-col>
          <v-data-table
            flat
            disable-sort
            disable-filtering
            :headers="headers"
            hide-default-footer
            :items-per-page="-1"
            :loading="isLoading"
            @click:row="handleSaleView($event)"
            class="table-striped grey lighten-4"
            :items="products.groupedSalesByDeliveryProducts.data"
          >
            <template v-slot:item.sale_number="{ item }">
              #{{ item.sale_number }}
            </template>

            <template v-slot:item.total_quantity="{ item }">
              {{ $format.decimal(item.total_quantity) }}
            </template>
            <template v-slot:item.quantity_to_delivery="{ item }">
              {{ $format.decimal(item.quantity_to_delivery) }}
            </template>
            <template v-slot:item.last_update="{ item }">
              {{ $format.dateBr(item.last_update) }}
            </template>

            <template v-slot:item.quantity_pending_delivery="{ item }">
              {{ $format.decimal(item.quantity_pending_delivery) }}
            </template>

            <template v-slot:item.quantity_delivered_confirmed="{ item }">
              {{ $format.decimal(item.quantity_delivered_confirmed) }}
            </template>
          </v-data-table>
          <app-pagination
            @click="select($event)"
            :data="products.groupedSalesByDeliveryProducts"
          />
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row class="pt-16">
        <v-col class="text-center">
          <v-icon size="48">mdi-magnify</v-icon>
          <div class="text-body">Pesquise um produto</div>
        </v-col>
      </v-row>
    </template>

    <SaleView ref="SaleView" @store="select()" />
  </div>
</template>
<script>
import SaleView from "@/components/sales/sections/SaleView.vue";
import ProductSearch from "@/components/product/ui/ProductSearch.vue";
import CompanySelect from "@/components/company/ui/CompanySelect.vue";

export default {
  components: {
    SaleView,
    ProductSearch,
    CompanySelect,
  },
  data() {
    return {
      headers: [
        { text: "N° Venda", value: "sale_number", align: "center" },
        { text: "Produto", value: "product_name", align: "start" },

        { text: "Quantidade Total", value: "total_quantity", align: "end" },

        {
          text: "Quantidade Para Entregar",
          value: "quantity_to_delivery",
          align: "end",
        },

        {
          text: "Quantidade Processando",
          value: "quantity_pending_delivery",
          align: "end",
        },

        {
          text: "Qtd Entregue/Em Rota",
          value: "quantity_delivered_confirmed",
          align: "end",
        },

        {
          text: "Última Atualização",
          value: "last_update",
          align: "end",
        },
      ],

      searchParams: {
        company_id: null,
        date_end: null,
        product_id: null,
        date_start: null,
        salesman_id: null,
        sale_status: ["sale"],
        order_direction: "asc",
        order_by: "last_update",
        delivery_status: ["not_delivered", "partial"],
      },

      products: { data: [], totals: {} },

      search: null,

      totals: {
        total_quantity: 0,
        total_delivered_quantity: 0,
        total_quantity_to_delivery: 0,
      },

      isLoading: false,
    };
  },

  computed: {},

  methods: {
    async select(page = 1) {
      this.searchParams.page = page;

      if (!this.searchParams.product_id) return;

      try {
        this.isLoading = true;

        const response = await this.$http.index(
          "/sale/sale-by-delivery-prod-report",
          this.searchParams
        );

        this.products = response;

        this.totals = response.totals || {
          total_quantity: 0,
          total_delivered_quantity: 0,
          total_quantity_to_delivery: 0,
        };
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    handleSearchInput(search) {
      this.searchParams.search = search ? search : null;
      this.select(1);
    },

    setProduct() {
      this.searchParams.product_id = this.search.product_variants[0].product_id;
      this.select(1);
    },

    handleSaleView(item) {
      this.$refs.SaleView.open(item.sale_id);
    },
  },
};
</script>
